(async () => {
  try { await window.GroundingPriceTest.ready; } catch { return; }
  const root = document.getElementById("GroundingKidsLanding");
  if (!root) return;
  "use strict";

  const CAMPAIGN_ID = "grounding-kids-lp-v1";
  const GIFT_RULES = [
    { key: "workbook", variantId: 51724047384881, unlockQuantity: 1 },
    { key: "stickers", variantId: 51943608877361, unlockQuantity: 1 },
    { key: "tote", variantId: 47446837985585, unlockQuantity: 2 },
    { key: "golden-ticket", variantId: 51943498055985, unlockQuantity: 3 },
  ];
  const parseData = (id, fallback = []) => {
    try {
      return JSON.parse(root.querySelector("#" + id)?.textContent || JSON.stringify(fallback));
    } catch (error) {
      console.warn("Grounding Kids landing data parse failed", error);
      return fallback;
    }
  };
  const fallbackImages = parseData("gklp-fallback-images-json");
  const galleryGroups = parseData("gklp-gallery-groups-json"),
    variantInfo = parseData("gklp-variant-info-json"),
    products = parseData("gklp-products-json", {});
  products.adult = window.GroundingPriceTest.mapProduct(products.adult);
  const commerceEnabled = root.dataset.commerceEnabled === "true";
  const imagesForColor = (color) =>
    galleryGroups
      .find((group) => group.color === color)
      ?.images?.filter(Boolean) || fallbackImages;
  let images = fallbackImages;
  const colors = [
    "Moon Grey",
    "Plum",
    "Teal",
    "Burgundy",
    "Forest Green",
    "Sky",
  ];
  // Keep generated swatches tied to the named CSS utilities used by static controls.
  const colorClass = (name) => name.toLowerCase().replace(/\s+/g, "-");
  const variantsForType = (type) => products[type]?.variants || [];
  const variantOption = (variant, index) =>
    variant?.options?.[index] || variant?.["option" + (index + 1)] || "";
  const sizesForItem = (itemOrType) => {
    const item = typeof itemOrType === "string" ? { type: itemOrType } : itemOrType;
    const variants = variantsForType(item?.type || "kid").filter(
      (variant) => !item?.color || variantOption(variant, 0) === item.color,
    );
    return [
      ...new Set(
        variants
          .filter((variant) => variant.available !== false)
          .map((variant) => variantOption(variant, 1))
          .filter(Boolean),
      ),
    ];
  };
  const variantForItem = (item) =>
    variantsForType(item.type).find(
      (variant) =>
        variant.available !== false &&
        variantOption(variant, 0) === item.color &&
        variantOption(variant, 1) === item.size,
    );
  const packs = {
    single: {
      name: "1 Hoodie",
      count: 1,
      discount: 10,
      items: [{ label: "Kid", color: "Moon Grey", size: "S", type: "kid" }],
    },
    siblings: {
      name: "Sibling Pack",
      count: 2,
      discount: 13,
      items: [
        { label: "Hoodie 1", color: "Moon Grey", size: "S", type: "kid" },
        { label: "Hoodie 2", color: "Sky", size: "L", type: "kid" },
      ],
    },
    three: {
      name: "3-Hoodie Family Pack",
      count: 3,
      discount: 25,
      items: [
        { label: "Hoodie 1", color: "Moon Grey", size: "S", type: "kid" },
        { label: "Hoodie 2", color: "Sky", size: "M", type: "kid" },
        { label: "Hoodie 3", color: "Plum", size: "L", type: "kid" },
      ],
    },
    momkid: {
      name: "Mom + Kid Pair",
      count: 2,
      discount: 13,
      items: [
        { label: "Mom", color: "Moon Grey", size: "M", type: "adult" },
        { label: "Kid", color: "Plum", size: "S", type: "kid" },
      ],
    },
  };
  images = imagesForColor(packs.single.items[0].color);
  let activePack = "single",
    inlineEditIndex = null,
    mainImage = 0;
  const $ = (s, r = root) => r.querySelector(s),
    $$ = (s, r = root) => [...r.querySelectorAll(s)];
  const moneyFormat = root.dataset.moneyFormat || "${{amount}}";
  const activeCurrency =
    root.dataset.currency || window.Shopify?.currency?.active || "CAD";
  const money = (cents) => {
    // Product JSON uses the visitor's presentment currency. Intl keeps the
    // symbol and decimal rules aligned with that market instead of forcing CAD.
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: activeCurrency,
      }).format(Number(cents || 0) / 100);
    } catch {
      const amount = (Number(cents || 0) / 100).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(Number(cents || 0) / 100)));
    }
  };
  const packPricing = (pack) => {
    const variants = pack.items.map(variantForItem);
    if (variants.some((variant) => !variant)) return null;
    const current = variants.reduce((sum, variant) => sum + Number(variant.price || 0), 0);
    const retail = variants.reduce(
      (sum, variant) => sum + Number(variant.compare_at_price || variant.price || 0),
      0,
    );
    // Each configured hoodie receives a unique cart-line marker. Calculate the
    // percentage per item so the estimate follows Shopify's line rounding.
    const total = variants.reduce(
      (sum, variant) =>
        sum + Math.round((Number(variant.price || 0) * (100 - pack.discount)) / 100),
      0,
    );
    return { variants, current, retail, total, save: Math.max(0, retail - total) };
  };
  const stickyBar = $(".sticky");
  const buyBox = $("#choose-pack");
  function revealStickyBar() {
    if (!stickyBar) return;
    stickyBar.hidden = false;
    stickyBar.setAttribute("aria-hidden", "false");
  }
  buyBox?.addEventListener("click", (event) => {
    const selectionControl = event.target.closest(
      ".gklp-tab, .offer-swatches .swatch, .offer-sizes .size, .gklp-builder-item, [data-inline-color], [data-inline-size]",
    );
    if (selectionControl) revealStickyBar();
  });
  function modelInfoFor(item) {
    if (!item || item.type === "adult") return "";
    return (
      variantInfo.find(
        (info) => info.color === item.color && info.size === item.size,
      )?.text || ""
    );
  }
  function updateSingleModelInfo() {
    $("#single-model-info").textContent = modelInfoFor(packs.single.items[0]);
  }
  function dots(container, count, current, onClick) {
    container.innerHTML = "";
    for (let i = 0; i < count; i++) {
      const b = document.createElement("button");
      b.type = "button";
      b.className = i === current ? "active" : "";
      b.setAttribute("aria-label", "View image " + (i + 1));
      b.onclick = () => onClick(i);
      container.appendChild(b);
    }
  }
  function renderMainGallery() {
    const img = $("#offer-gallery-image"),
      d = $("#offer-gallery-dots");
    if (!img || !d) return;
    if (!images.length) images = fallbackImages;
    if (mainImage >= images.length) mainImage = 0;
    img.src = images[mainImage];
    dots(d, images.length, mainImage, (i) => {
      mainImage = i;
      renderMainGallery();
    });
  }
  function renderPreview(key) {
    const box = $('[data-preview="' + key + '"]');
    if (!box) return;
    const strong = box.querySelector("strong");
    box.innerHTML = "";
    box.appendChild(
      strong ||
        Object.assign(document.createElement("strong"), {
          textContent: "Your selections",
        }),
    );
    packs[key].items.forEach((it) => {
      const s = document.createElement("span");
      s.textContent =
        it.label +
        ": " +
        it.color +
        " / " +
        (it.type === "adult" ? "Adult " : "") +
        it.size;
      box.appendChild(s);
    });
  }
  function renderBuilder() {
    const p = packs[activePack],
      single = $("#gklp-single-builder"),
      multi = $("#gklp-multi-builder"),
      sub = $("#gklp-builder-sub"),
      builder = $(".gklp-builder"),
      activeTab = $('.gklp-tab[data-pack="' + activePack + '"]');
    activeTab.insertAdjacentElement("afterend", builder);
    const isSingle = activePack === "single";
    single.hidden = !isSingle;
    multi.hidden = isSingle;
    sub.textContent = isSingle
      ? "Choose one color and size."
      : "Edit each hoodie to choose its color and size.";
    if (isSingle) return;
    const items = $("#gklp-builder-items");
    items.innerHTML = p.items
      .map((it, index) => {
        const open = inlineEditIndex === index,
          model = modelInfoFor(it);
        return (
          '<div class="gklp-builder-card ' +
          (open ? "is-open" : "") +
          '"><button type="button" class="gklp-builder-item" data-builder-index="' +
          index +
          '" aria-expanded="' +
          open +
          '"><span class="gklp-builder-thumb"><img src="' +
          (imagesForColor(it.color)[0] || fallbackImages[0]) +
          '" alt=""></span><span><strong>' +
          it.label +
          "</strong><small>" +
          it.color +
          " / " +
          (it.type === "adult" ? "Adult " : "") +
          it.size +
          '</small></span><span class="gklp-builder-edit">' +
          (open ? "Done" : "Edit") +
          '</span></button><div class="gklp-inline-editor" ' +
          (open ? "" : "hidden") +
          '><div class="gklp-inline-group"><div class="label">Color <span class="note">' +
          it.color +
          ' selected</span></div><div class="swatches">' +
          colors
            .map(
              (name) =>
                '<button type="button" class="swatch ' +
                (name === it.color ? "active" : "") +
                '" data-inline-color data-builder-index="' +
                index +
                '" data-value="' +
                name +
                '" aria-label="' +
                name +
                '"><span class="swatch-color swatch-color--' +
                colorClass(name) +
                '"></span></button>',
            )
            .join("") +
          '</div></div><div class="gklp-inline-group"><div class="size-row"><div class="label">Size <span class="note">' +
          (it.type === "adult" ? "Adult " : "") +
          it.size +
          " selected</span>" +
          (model ? '<span class="gklp-model-info">' + model + "</span>" : "") +
          '</div><button class="link" type="button" data-size-guide-open-inline>Size Guide</button></div><div class="sizes">' +
          sizesForItem(it)
            .map(
              (size) =>
                '<button type="button" class="size ' +
                (size === it.size ? "active" : "") +
                '" data-inline-size data-builder-index="' +
                index +
                '" data-value="' +
                size +
                '">' +
                size +
                "</button>",
            )
            .join("") +
          "</div></div></div></div>"
        );
      })
      .join("");
    $$("[data-builder-index].gklp-builder-item", items).forEach(
      (button) =>
        (button.onclick = () => {
          const index = Number(button.dataset.builderIndex);
          inlineEditIndex = inlineEditIndex === index ? null : index;
          renderBuilder();
        }),
    );
    $$("[data-inline-color]", items).forEach(
      (button) =>
        (button.onclick = () => {
          const index = Number(button.dataset.builderIndex);
          p.items[index].color = button.dataset.value;
          // Keep the selection purchasable when a color does not offer the
          // previously selected size.
          const availableSizes = sizesForItem(p.items[index]);
          if (!availableSizes.includes(p.items[index].size)) {
            p.items[index].size = availableSizes[0] || p.items[index].size;
          }
          images = imagesForColor(button.dataset.value);
          mainImage = 0;
          inlineEditIndex = index;
          renderMainGallery();
          renderBuilder();
          updateOffer();
        }),
    );
    $$("[data-inline-size]", items).forEach(
      (button) =>
        (button.onclick = () => {
          const index = Number(button.dataset.builderIndex);
          p.items[index].size = button.dataset.value;
          inlineEditIndex = index;
          renderBuilder();
          updateOffer();
        }),
    );
    $$("[data-size-guide-open-inline]", items).forEach(
      (button) => (button.onclick = () => $("#gklp-size-guide").showModal()),
    );
  }
  function selectPack(key) {
    if (activePack !== key) inlineEditIndex = null;
    activePack = key;
    const p = packs[key];
    images = imagesForColor(p.items[0].color);
    mainImage = 0;
    $$(".gklp-tab").forEach((tab) => {
      const on = tab.dataset.pack === key;
      tab.classList.toggle("is-active", on);
      tab.setAttribute("aria-selected", String(on));
    });
    renderMainGallery();
    renderBuilder();
    updateOffer();
  }
  function updatePackTabs() {
    $$(".gklp-tab").forEach((tab) => {
      const pack = packs[tab.dataset.pack],
        pricing = pack && packPricing(pack);
      if (!pricing) return;
      const displayedPrice =
        pack.count === 1
          ? money(pricing.total)
          : money(Math.round(pricing.total / pack.count)) + " each";
      const price = tab.querySelector("[data-pack-price]"),
        save = tab.querySelector("[data-pack-save]");
      if (price) price.textContent = displayedPrice;
      if (save) save.textContent = money(pricing.save);
    });
  }
  function updateOffer() {
    const p = packs[activePack],
      pricing = packPricing(p),
      addButton = $("#offer-add-cart");
    $("#gift-pack-count").textContent =
      p.count + " " + (p.count === 1 ? "hoodie" : "hoodies");
    $("#gift-progress").dataset.progress = String(
      p.count === 1 ? 34 : p.count === 2 ? 67 : 100,
    );
    $("#gift-copy").textContent =
      p.count === 1
        ? "Workbook + stickers included."
        : p.count === 2
          ? "Cloud Tote unlocked with this pack."
          : "All gifts unlocked, including Golden Ticket.";
    $$("[data-gift-tier]").forEach((card) => {
      const tier = +card.dataset.giftTier,
        locked = p.count < tier;
      card.classList.toggle("locked", locked);
      const state = card.querySelector(".gift-state");
      state.textContent = locked
        ? "Add " +
          (tier - p.count) +
          " " +
          (tier - p.count === 1 ? "hoodie" : "hoodies")
        : "Included";
    });
    $("#summary-pack").textContent = p.name + " · " + p.discount + "% off";
    $("#summary-selections").textContent = p.items
      .map(
        (it) =>
          it.color + " / " + (it.type === "adult" ? "Adult " : "") + it.size,
      )
      .join(" · ");
    updatePackTabs();
    if (!pricing) {
      addButton.disabled = true;
      addButton.textContent = "Selected option is unavailable";
      return;
    }
    $("#summary-retail").textContent = money(pricing.retail);
    $("#summary-save").textContent = money(pricing.save);
    $("#summary-total").textContent = money(pricing.total);
    addButton.disabled = !commerceEnabled;
    addButton.textContent = commerceEnabled
      ? "Add selected pack to cart · " + money(pricing.total)
      : "Offer checkout is not enabled yet";
    const stickyPrice = $("#prototype-sticky-price"),
      stickyCopy = $("#prototype-sticky-copy");
    if (stickyPrice) stickyPrice.textContent = money(pricing.total);
    if (stickyCopy) {
      stickyCopy.textContent =
        p.name + " · " + p.discount + "% off · 30-day fit & satisfaction support";
    }
    updateSingleModelInfo();
  }
  $$(".gklp-tab").forEach(
    (tab) => (tab.onclick = () => selectPack(tab.dataset.pack)),
  );
  $$(".offer-swatches .swatch").forEach(
    (b) =>
      (b.onclick = (e) => {
        e.stopPropagation();
        $$(".offer-swatches .swatch").forEach((x) =>
          x.classList.remove("active"),
        );
        b.classList.add("active");
        packs.single.items[0].color = b.dataset.value;
        const availableSizes = sizesForItem(packs.single.items[0]);
        if (!availableSizes.includes(packs.single.items[0].size)) {
          packs.single.items[0].size = availableSizes[0] || packs.single.items[0].size;
          $("#single-size-label").textContent = packs.single.items[0].size + " selected";
        }
        $("#single-color-label").textContent = b.dataset.value + " selected";
        selectPack("single");
      }),
  );
  $$(".offer-sizes .size").forEach(
    (b) =>
      (b.onclick = (e) => {
        e.stopPropagation();
        $$(".offer-sizes .size").forEach((x) => x.classList.remove("active"));
        b.classList.add("active");
        packs.single.items[0].size = b.dataset.value;
        $("#single-size-label").textContent = b.dataset.value + " selected";
        selectPack("single");
      }),
  );
  $(".gallery-prev").onclick = () => {
    mainImage = (mainImage - 1 + images.length) % images.length;
    renderMainGallery();
  };
  $(".gallery-next").onclick = () => {
    mainImage = (mainImage + 1) % images.length;
    renderMainGallery();
  };
  const sizeGuideDialog = $("#gklp-size-guide");
  $$("[data-size-guide-open]").forEach(
    (button) => (button.onclick = () => sizeGuideDialog.showModal()),
  );
  $("[data-size-guide-close]").onclick = () => sizeGuideDialog.close();
  sizeGuideDialog.addEventListener("click", (event) => {
    if (event.target === sizeGuideDialog) sizeGuideDialog.close();
  });
  const sizeRegion = $("[data-size-region]"),
    sizeUnitButtons = $$("[data-size-unit]");
  let sizeUnit = "inches";
  function renderSizeGuide() {
    const key = sizeRegion.value + "-" + sizeUnit;
    $$("[data-size-panel]").forEach(
      (panel) => (panel.hidden = panel.dataset.sizePanel !== key),
    );
    sizeUnitButtons.forEach((button) => {
      const active = button.dataset.sizeUnit === sizeUnit;
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", String(active));
    });
  }
  sizeRegion.addEventListener("change", renderSizeGuide);
  sizeUnitButtons.forEach(
    (button) =>
      (button.onclick = () => {
        sizeUnit = button.dataset.sizeUnit;
        renderSizeGuide();
      }),
  );
  renderSizeGuide();
  function showToast(title, message, isError = false) {
    const toast = $("#offer-toast");
    toast.querySelector("strong").textContent = title;
    toast.querySelector("span").textContent = message;
    toast.classList.toggle("is-error", isError);
    toast.hidden = false;
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(() => (toast.hidden = true), 4200);
  }
  function cartItemsForPack(pack, instance) {
    const pricing = packPricing(pack);
    if (!pricing) return null;
    const items = pack.items.map((item, index) => ({
      id: pricing.variants[index].id,
      quantity: 1,
      properties: {
        _landing_offer_campaign: CAMPAIGN_ID,
        _landing_offer_instance: instance,
        _landing_offer_pack: activePack,
        // A unique line marker prevents equal variants from merging. That
        // keeps percentage rounding and each configured selection predictable.
        _landing_offer_line: `${activePack}-${index + 1}-${instance}`,
        _landing_offer_role: "qualifying",
        _bundle_name: pack.name,
      },
    }));
    GIFT_RULES.filter((gift) => gift.unlockQuantity <= pack.count).forEach(
      (gift) => {
        items.push({
          id: gift.variantId,
          quantity: 1,
          properties: {
            _landing_offer_campaign: CAMPAIGN_ID,
            _landing_offer_instance: instance,
            _landing_offer_pack: activePack,
            _landing_offer_line: `gift-${gift.key}-${instance}`,
            _landing_offer_role: "gift",
            _landing_offer_gift: "1",
            _landing_offer_gift_key: gift.key,
          },
        });
      },
    );
    return items;
  }
  $("#offer-add-cart").onclick = async () => {
    if (!commerceEnabled) return;
    const button = $("#offer-add-cart"),
      pack = packs[activePack],
      instance = `gklp-${
        window.crypto?.randomUUID?.() || Date.now().toString(36)
      }`,
      items = cartItemsForPack(pack, instance);
    if (!items) {
      showToast(
        "Choose another option",
        "One of the selected variants is no longer available.",
        true,
      );
      return;
    }
    button.disabled = true;
    button.textContent = "Adding your offer…";
    try {
      const response = await fetch(window.routes?.cart_add_url || "/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ items }),
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok || Number(result?.status) >= 400 || result?.errors) {
        throw new Error(result?.description || result?.message || "Cart add failed.");
      }
      showToast("Added to cart", "Your discounted pack and free gifts are ready.");
      document.dispatchEvent(
        new CustomEvent("cart:refresh", { detail: { source: "grounding-kids-landing" } }),
      );
      window.dispatchEvent(
        new CustomEvent("cart:refresh", { detail: { source: "grounding-kids-landing" } }),
      );
      if (window.kachingCartApi?.openCart) {
        await window.kachingCartApi.refreshCart?.();
        window.kachingCartApi.openCart();
      } else {
        window.location.assign(root.dataset.cartUrl || "/cart");
      }
    } catch (error) {
      showToast(
        "Could not add this pack",
        error?.message || "Please check your selections and try again.",
        true,
      );
    } finally {
      updateOffer();
    }
  };
  renderMainGallery();
  Object.keys(packs)
    .filter((k) => k !== "single")
    .forEach(renderPreview);
  renderBuilder();
  updateOffer();
})();
